import ErrorBoundary from 'components/error-boundaries';
import classNames from 'classnames';
import Table, { Body } from 'modules/shared-components/data-display/table';
import {
  followersColumns,
  Follower,
} from 'modules/marketplace-performance-page/components/followers-chart-column';
import { StrategyPerformance } from 'api/types/httpsTypes/marketplace-performance';
import {
  followersPerformance,
  tradesPerformance,
} from 'modules/marketplace-performance-page/components/main-info-list-component';
import moment from 'moment';
import { DATE_FORMAT } from 'modules/marketplace-performance-page/constants/DATE_FORMAT';
import Tooltip from 'modules/shared-components/tooltip';
import Big from 'big.js';

const MainPerformance = ({ mainPerformance }: StrategyPerformance) => {
  interface MainListProps {
    title: string;
    value: string | number;
    prefix?: string;
    suffix?: string;
    tooltip?: string;
  }

  const MainListComponent = ({
    title,
    prefix,
    value,
    suffix,
    tooltip,
  }: MainListProps) => {
    return (
      <div className="xxs:px-4 xxs:py-3 xxs:mb-2">
        <div className="flex justify-between">
          <div className="text-sm">
            {title} <Tooltip.Info text={tooltip} />
          </div>
          <div className="text-sm font-medium">
            {prefix}
            {value}
            {suffix}
          </div>
        </div>
      </div>
    );
  };

  return (
    <ErrorBoundary>
      <div className=" ">
        <div className="flex justify-center xxs:mb-2 items-center border-bottom-new border-b-1 xxs:border-b-1 xxs:border-black-50 dark:border-black-400 xxs:py-4">
          <div className="text-center">
            {mainPerformance?.last30DaysReturn && (
              <div
                className={classNames(
                  'text-3xl font-medium',
                  mainPerformance?.last30DaysReturn > 0 && 'text-green-success',
                  mainPerformance?.last30DaysReturn === 0 && 'text-red-warning'
                )}
              >
                {mainPerformance?.last30DaysReturn > 0 && '+'}
                {Big(mainPerformance?.last30DaysReturn).mul(100).toFixed(2)}%
              </div>
            )}
            <div>30D Returns</div>
          </div>
        </div>
        {tradesPerformance(mainPerformance).map((tradePerformance) => (
          <MainListComponent
            key={tradePerformance.title}
            {...tradePerformance}
          />
        ))}
        <div className="xxs:px-4 xxs:pt-3 xxs:pb-4  border-bottom-new border-b-1 xxs:border-b-1 xxs:border-black-50 dark:border-black-400">
          <div className="flex justify-between">
            <div className="text-sm">Last Trade</div>
            <div className="text-sm font-medium">
              {moment(mainPerformance?.lastTrade).format(DATE_FORMAT)}
            </div>
          </div>
        </div>
        <div className="xxs:pt-3 xxs:pb-4  border-bottom-new border-b-1 xxs:border-b-1 xxs:border-black-50 dark:border-black-400">
          {followersPerformance(mainPerformance).map(
            (followerPerformance, index) => (
              <MainListComponent {...followerPerformance} key={index} />
            )
          )}
        </div>
        {mainPerformance && mainPerformance?.bestFollowers.length > 0 && (
          <div className=" xxs:p-4 xxs:mt-2">
            <div>30D Best Followers</div>
            <div className="flex flex-col my-2 max-w-full overflow-auto gap-2">
              <Table>
                <Table.Header columns={followersColumns} />
                <Body
                  columns={followersColumns}
                  data={
                    [...(mainPerformance?.bestFollowers || [])].map(
                      (follower, index) => ({
                        ...follower,
                        id: `${index}`,
                      })
                    ) as Follower[]
                  }
                />
              </Table>
            </div>
          </div>
        )}
        {/*  <div className="xxs:p-4">
          <div>Other Bots</div>
          CARDS HERE
        </div>*/}
      </div>
    </ErrorBoundary>
  );
};
export default MainPerformance;
